<template>
    <div class="main">

        <div class="role_left">
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>角色列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openDialog">创建角色</el-button>
                </p>
            </div>

            <el-table :data="roleList" style="width: 100%;" height="650">

                <el-table-column prop="roleName" label="角色名称" min-width="29%">
                </el-table-column>

                <el-table-column prop="roleDescription" label="角色描述" min-width="29%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" min-width="42%">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="系统管理员不允许编辑和删除">
                            <span>操作</span>
                        </el-tooltip>
                    </template>

                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="success" round size="small"
                            v-if="scope.row.allowEdit != 0">
                            {{ scope.row.allowEdit == 0 ? '' : '编辑' }}
                        </el-button>

                        <el-button @click="bindClick(scope.row)" type="success" round size="small">
                            绑定员工
                        </el-button>

                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                            v-if="scope.row.allowEdit != 0">
                            {{ scope.row.allowEdit == 0 ? '' : '删除' }}
                        </el-button>

                        <el-button @click="checkClick(scope.row)" type="success" round size="small">
                            查看权限
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="角色编辑" :visible.sync="dlgFormVisible" width="40%">
                <el-form :model="form">
                    <el-form-item label="角色名称" required :label-width="formLabelWidth">
                        <el-input v-model="form.roleName" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="角色描述" required :label-width="formLabelWidth">
                        <el-input v-model="form.roleDescription" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dlgFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addRole">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="员工绑定" :visible.sync="dlgTableVisible">
                <div style="position: relative;right:-500px; width: 300px;">
                    <el-input placeholder="请输入姓名" v-model="queryValue" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="searchEmp"></el-button>
                    </el-input>
                </div>

                <el-table :data="empList" height="620">

                    <el-table-column prop="employeeCode" label="代号" width="100"></el-table-column>
                    <el-table-column property="employeeName" label="姓名" width="150"></el-table-column>
                    <el-table-column property="phone" label="注塑号" width="200"></el-table-column>
                    <el-table-column property="roleDescription" label="角色" width="270"></el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="bindOrNoClick(scope.row)" type="text" size="small" style="color:green">
                                {{ scope.row.userRoleId == null ? '绑定' : '取消绑定' }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div>
                    <el-pagination background :page-size="pageNum" :page-count="pageCount"
                        layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                        :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
                    </el-pagination>
                </div>
            </el-dialog>
        </div>

        <div style="padding-top: 20px;">&nbsp;>>>>&nbsp;</div>

        <div class="role_right">

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b><span style="color:blue">【{{ showRoleDescription }}】</span>拥有的权限</b>
                </p>
                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="savePermission">保存</el-button>
                </p>
            </div>

            <div style="height:95%;overflow:auto;padding-bottom: 10px;">
                <!-- 权限树 （show-checkbox：是否显示复选框，node-key：整棵树的唯一标识，default-expand-all：是否默认展开所有节点，
                    expand-on-click-node：为false时，只有点击箭头才能展开和收缩节点；default-checked-keys：默认勾选的节点的 key 的数组）-->
                <el-tree :data="permissionTree" show-checkbox node-key="id" default-expand-all
                    :expand-on-click-node="false" :default-checked-keys="checkedIds" :check-strictly="true"
                    @check-change="checkChange" ref="tree">

                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span @click="() => editClick(node, data)">
                            <i :class="data.icon"></i>&nbsp;

                            <el-tag size="mini" :type="data.type == '模块' ? '' : data.type == '菜单' ? 'warning' : 'info'">
                                {{ data.type }}</el-tag>&nbsp;

                            <span>{{ node.label }}</span>
                        </span>
                    </span>

                </el-tree>
            </div>
        </div>
    </div>
</template>

<script>
import globalMethod from "@/method/globalMethod.js";

export default {
    name: "Role",
    mixins: [globalMethod],
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            roleList: [],
            dlgFormVisible: false,
            form: {
                roleId: '',
                roleName: '',
                roleDescription: ''
            },

            formLabelWidth: '100px',
            dlgTableVisible: false,
            empList: [],
            checkedIds: [],

            preCheckedKeys: [],
            currentCheckedKeys: [],
            showRoleDescription: '',
            permissionTree: [{
                id: '1',
                label: '看板管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '10',
                    label: '生产看板',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '11',
                    label: '品质看板',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '2',
                label: '基础资料',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '20',
                    label: '首检项目',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '21',
                    label: '产品类别',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '22',
                    label: '产品资料',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '220',
                        label: '导出',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '23',
                    label: '客户资料',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '3',
                label: '订单管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '30',
                    label: '客户下单',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '300',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '301',
                        label: '下单',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '302',
                        label: '更改',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '303',
                        label: '审核',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '304',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '305',
                        label: '导出',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '306',
                        label: '生成订单',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '307',
                        label: '拒接',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '308',
                        label: '再次下单',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '31',
                    label: '产品订单',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '310',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '311',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '312',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '32',
                    label: '模具整备',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '320',
                        label: '整备',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '321',
                        label: '确认',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '322',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '4',
                label: '生产管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '40',
                    label: '订单排产',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '400',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '401',
                        label: '排产',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '402',
                        label: '上机',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '403',
                        label: '首检',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '404',
                        label: '产中停',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '405',
                        label: '完成',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '41',
                    label: '设备管理',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '5',
                label: '计件管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '50',
                    label: '计件记录',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '500',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '501',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '502',
                        label: '审批',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '51',
                    label: '员工统计',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '6',
                label: '品质管控',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '60',
                    label: '巡检点',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '61',
                    label: '巡检记录',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '62',
                    label: '巡检统计',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '7',
                label: '仓库管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '70',
                    label: '库存',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '71',
                    label: '入库',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '72',
                    label: '出库',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '720',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '721',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '722',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '723',
                        label: '接收',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '724',
                        label: '退回',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '725',
                        label: '审批',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '726',
                        label: '打单',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '8',
                label: '报表管理',
                type: '模块',
                icon: 'el-icon-document',
                children: []
            }, {
                id: '9',
                label: '工厂管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '90',
                    label: '公司信息',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '900',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '901',
                        label: '注销',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '91',
                    label: '班次时间',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '92',
                    label: '考勤管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '920',
                        label: '审批',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '93',
                    label: '部门管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '930',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '931',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '932',
                        label: '绑定角色',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '933',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '94',
                    label: '员工管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '940',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '941',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '95',
                    label: '角色&权限',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '950',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '951',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '952',
                        label: '绑定员工',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '953',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '954',
                        label: '查看权限',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '955',
                        label: '保存',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }],
            tagType: 'warning',

            queryValue: '',
            loading: false,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        searchEmp(query) {

            this.empList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getEmpsByRoleId()
                }, 200)

            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        openDialog() {

            this.form.roleId = ''
            this.form.roleName = ''
            this.form.roleDescription = ''

            this.dlgFormVisible = true
        },
        handleClick(row) {
            //console.log(row)

            this.form.roleId = row.roleId
            this.dlgFormVisible = true
            this.form.roleName = row.roleName
            this.form.roleDescription = row.roleDescription
        },
        addRole() {
            this.$axios({
                method: "post",
                url: "/shiro/role/add",
                data: {
                    roleId: this.form.roleId,
                    roleName: this.form.roleName,
                    roleDescription: this.form.roleDescription,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.dlgFormVisible = false

                this.getRoles()

                this.$message({
                    type: 'success',
                    message: data.msg
                })
            })
        },
        getRoles() {
            this.$axios({
                method: "post",
                url: "/shiro/role/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.roleList = data.data

                this.showRoleDescription = this.roleList[0].roleDescription

                //默认选中第一个角色
                this.checkedIds = this.getPermissionIds(this.roleList[0].roleId)

                this.form.roleId = this.roleList[0].roleId
            })
        },
        getEmpsByRoleId() {

            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll/roleId",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    roleId: this.form.roleId,
                    queryParam: this.queryValue,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                this.empList = result.data.data

                for (let key in this.empList) {
                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status = this.empList[key].status == 1 ? '启用' : '禁用'
                }

                this.total = this.empList[0].total
            })
        },
        bindClick(row) {

            this.form.roleId = row.roleId

            this.dlgTableVisible = true

            this.getEmpsByRoleId()

            // console.log('call')
            // console.log(this.empList)
        },
        bindOrNoClick(row) {
            if (row.userRoleId == null) {
                this.bindEmp(row)
            } else {
                this.unBindEmp(row)
            }
        },
        bindEmp(row) {
            this.$axios({
                method: "post",
                url: "/shiro/employee/bind",
                data: {
                    userId: row.userId,
                    roleId: this.form.roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.getEmpsByRoleId()
            })
        },
        unBindEmp(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/employee/unBind",
                data: {
                    userRoleId: row.userRoleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.getEmpsByRoleId()
            })
        },
        deleteClick(row) {

            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeRole(row)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeRole(row) {

            this.$axios({
                method: "delete",
                url: "/shiro/role/remove",
                data: {
                    roleId: row.roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.$message({
                    message: result.data.msg
                })

                this.getRoles()
            })
        },
        checkClick(row) {//查看某个角色的权限

            this.showRoleDescription = row.roleDescription

            this.getPermissionIds(row.roleId)

            this.form.id = row.id
            this.form.roleId = row.roleId
        },
        getPermissionIds(roleId) {
            this.$axios({
                method: "post",
                url: "/shiro/role/permission/get",
                data: {
                    roleId: roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        message: data.msg
                    })
                }

                this.checkedIds = data.data

                this.$refs.tree.setCheckedKeys(this.checkedIds)

                //初始化
                this.preCheckedKeys = this.$refs.tree.getCheckedKeys()

            })
        },
        checkChange(data, checked, indeterminate) {
            // console.log(data, checked, indeterminate)


            this.currentCheckedKeys = this.$refs.tree.getCheckedKeys()

            //如果执行的是取消勾选操作
            if (this.preCheckedKeys.length > this.currentCheckedKeys.length) {

                for (let i in this.preCheckedKeys) {
                    for (let j in this.currentCheckedKeys) {
                        //console.log(preCheckedKeys[i]);
                        //console.log(this.currentCheckedKeys[j]);

                        if (this.preCheckedKeys[i] === this.currentCheckedKeys[j]) {

                            this.preCheckedKeys.splice(i, 1)
                        }
                    }
                }

                let node = this.$refs.tree.getNode(this.preCheckedKeys[0])
                // console.log('node')
                // console.log(node)

                //如果取消勾选的不是叶子节点
                if (node != null && node.checked === false && node.isLeaf === false) {
                    const arr = []
                    node.childNodes.forEach(element => {

                        arr.push(element.data.id)

                        if (element.childNodes.length != 0) {

                            element.childNodes.forEach(el => {
                                arr.push(el.data.id)
                            })
                        }
                    })
                    //this.$refs.tree.setCheckedKeys(arr)
                    // console.log('arr')
                    // console.log(arr)

                    //把所有子节点都取消勾选
                    for (let i in arr) {
                        this.$refs.tree.getNode(arr[i]).checked = false
                    }
                }

            } else {
                // console.log('jl')

                for (let i in this.preCheckedKeys) {
                    for (let j in this.currentCheckedKeys) {

                        if (this.preCheckedKeys[i] === this.currentCheckedKeys[j]) {

                            this.currentCheckedKeys.splice(j, 1)
                            // console.log('s')
                        }
                    }
                }

                // console.log('currentCheckedKeys---2')
                // console.log(this.currentCheckedKeys)

                let node = this.$refs.tree.getNode(this.currentCheckedKeys[0])

                // console.log('node---2')
                // console.log(node)

                //如果勾选的不是叶子节点
                if (node != null && node.checked === true && node.isLeaf === false) {
                    const arr = []
                    node.childNodes.forEach(element => {

                        arr.push(element.data.id)

                        if (element.childNodes.length != 0) {

                            element.childNodes.forEach(el => {
                                arr.push(el.data.id)
                            })
                        }
                    })

                    // console.log('arr---2')
                    // console.log(arr)

                    //把所有子节点都勾选
                    for (let i in arr) {
                        this.$refs.tree.getNode(arr[i]).checked = true
                    }
                }
            }

        },
        savePermission() {

            let permissionIds = this.$refs.tree.getCheckedKeys()

            this.$axios({
                method: "post",
                url: "/shiro/role/permission/modify",
                data: {
                    roleId: this.form.roleId,
                    permissionIdSet: permissionIds,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                if (result.data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: result.data.msg
                    })
                } else {
                    this.$message({
                        type: 'info',
                        message: result.data.msg
                    })
                }
            })
        },
        pageClick(currentPage) {

            this.empList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getEmpsByRoleId()
        },
        handleSizeChange(val) {

            this.pageNum = val

            this.getEmpsByRoleId()
        },
    },
    mounted() {
        //console.log('mounted')
        this.setDefaultPath('/role')

        this.getRoles()
    }
}
</script>

<style>
.main {
    display: flex;
    height: 95%;
}

.role_left {
    width: 68%;
    /* height: 98%; */
    /* display: inline; */
    /* float: left; */
}

.role_right {
    width: 30%;
    /* height:750px; */
    /* display: inline; */
    /* float: right; */
}

.el-tree {
    height: 99%;
}

.role_p {
    position: relative;
    right: 5px;
    width: 120px;
    margin: 10px 0px 30px 0px;
}

.role_span {
    border: 1px solid #6f5499;
    border-radius: 5px;
    margin: 0px 10px;
    font-size: 13px;
    color: #6f5499;
}

.el-pagination__total {
    color: green;
}
</style>